import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function Home() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "SoftwareApplication",
          "name": "Biznify POS System",
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Web",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          },
          "description": "Professional point-of-sale solution for retail operations with high-speed checkout, secure transactions, and user-centered design.",
          "url": import.meta.env.VITE_SITE_URL || "https://example.com",
          "publisher": {
            "@type": "Organization",
            "name": "Softifybd Ltd",
            "url": import.meta.env.VITE_SITE_URL || "https://example.com"
          },
          "featureList": [
            "High-Speed Checkout",
            "Secure Transactions",
            "User-Centered Design",
            "Cash Drawer Management",
            "Customer Management",
            "Product Search",
            "Receipt Printing"
          ]
        },
        {
          "@type": "Organization",
          "name": "Softifybd Ltd",
          "url": import.meta.env.VITE_SITE_URL || "https://example.com",
          "logo": "https://static.readdy.ai/image/82828e1ff69cacd1e8315694d834201a/a7aa8dc7c18109be11ac3b90149a8c3a.png",
          "description": "Softifybd Ltd provides professional business software solutions including the Biznify POS System for retail operations."
        },
        {
          "@type": "WebPage",
          "name": "Biznify POS System - Professional Point of Sale Solution",
          "description": "Biznify POS System offers professional point-of-sale solutions for retail operations with high-speed checkout, secure transactions, and user-centered design.",
          "url": import.meta.env.VITE_SITE_URL || "https://example.com"
        }
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle sign in logic here
  };

  return (
    <div 
      className="relative flex flex-col items-center justify-center min-h-screen px-4 py-8"
      style={{
        backgroundImage: 'url(https://static.readdy.ai/image/82828e1ff69cacd1e8315694d834201a/02729a0bd7704f1310dd99c4c0c28996.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Login Card */}
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Header with gradient border */}
        <div className="relative">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-500 via-teal-600 to-blue-600"></div>
          
          {/* Logo and Welcome Text */}
          <div className="pt-8 pb-6 px-8 text-center">
            <div className="flex items-center justify-center mb-6">
              <img 
                src="https://static.readdy.ai/image/82828e1ff69cacd1e8315694d834201a/959c31c053d3c4ee4b7a3e73b52593a2.png" 
                alt="Softifybd Logo" 
                className="h-12 w-auto"
              />
            </div>
            
            <p className="text-sm text-gray-600 leading-relaxed">
              Welcome back! Get started with Softifybd. No credit card required. Get 14 days free trial.
            </p>
          </div>

          {/* Collapse/Expand Icons */}
          <div className="absolute top-6 right-6 flex flex-col gap-2">
            <button className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer">
              <i className="ri-subtract-line text-xl"></i>
            </button>
            <button className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer">
              <i className="ri-arrow-up-s-line text-xl"></i>
            </button>
            <button className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer">
              <i className="ri-arrow-up-s-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Form Content */}
        <div className="px-8 pb-8">
          {/* Google Sign In */}
          <button className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-white border-2 border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer mb-6">
            <svg width="20" height="20" viewBox="0 0 20 20">
              <path d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z" fill="#4285F4"/>
              <path d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z" fill="#34A853"/>
              <path d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z" fill="#FBBC05"/>
              <path d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z" fill="#EA4335"/>
            </svg>
            <span className="font-medium text-gray-700">Continue with Google</span>
          </button>

          {/* Divider */}
          <div className="relative mb-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-white text-gray-500">OR</span>
            </div>
          </div>

          {/* Email and Password Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Email Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all"
                placeholder="Enter your email"
              />
            </div>

            {/* Password Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all pr-12"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className={`${showPassword ? 'ri-eye-off-line' : 'ri-eye-line'} text-xl`}></i>
                </button>
              </div>
            </div>

            {/* Sign In Button */}
            <Link
              to="/pos-checkin"
              className="w-full block text-center px-4 py-3 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-lg font-medium transition-all cursor-pointer whitespace-nowrap"
            >
              Sign in
            </Link>
          </form>
        </div>

        {/* Footer */}
        <div className="px-8 pb-6 text-center">
          <p className="text-xs text-gray-500">
            Powered by Biznify. A Product by Softifybd Ltd.
          </p>
        </div>
      </div>
    </div>
  );
}
